<vc-spinner *ngIf="!unverifiedAppointments"></vc-spinner>

<div
   *ngIf="unverifiedAppointments"
   class="cards-container">
   <div *ngIf="unverifiedAppointments.length == 0">There are no unverified clients</div>

   <div
      *ngIf="unverifiedAppointments.length > 0"
      style="margin-top: 8px">
      {{ unverifiedAppointments.length }} Unverified Clients
   </div>

   <p-button
      *ngIf="unverifiedAppointments?.length"
      icon="pi pi-print"
      label="Printable Table"
      severity="secondary"
      outlined
      size="small"
      (onClick)="openPrintableTable()"></p-button>

   <div
      *ngFor="let app of unverifiedAppointments"
      class="appointment-card">
      <div class="field-row">
         <div class="label">{{ app.startTime > today ? "Next Visit:" : "Last Visit:" }}</div>
         <div class="value">{{ app.startTime | date : "longDate" }}</div>
      </div>

      <div class="field-row">
         <div class="label">Client Name:</div>
         <div class="value">{{ app.displayName }}</div>
      </div>
      <div class="field-row">
         <div class="label">Client ID:</div>
         <div class="value">{{ app.friendlyId }}</div>
      </div>

      <div class="field-row">
         <div class="label">Email Address:</div>
         <div class="value">
            <div>
               {{ app.emailAddress }}
               <span style="margin-left: 0.5rem">
                  {{ app.isEmailVerified ? "✅" : app.emailVerificationErrorType === "2" ? "⚠" : "❌" }}
               </span>
            </div>

            <div
               *ngIf="!app.isEmailVerified"
               [ngClass]="{
                  'error-message': true,
                  'error-warning': app.emailVerificationErrorType === '2'
               }">
               ({{ errorTypeMap[app.emailVerificationErrorType || 0] }})
            </div>
         </div>
      </div>

      <div class="field-row">
         <div class="label">Phone:</div>
         <div class="value">
            <div>
               {{ app.phone }}
               <span style="margin-left: 0.5rem">
                  {{ app.isPhoneVerified ? "✅" : app.phoneVerificationErrorType === "2" ? "⚠" : "❌" }}
               </span>
            </div>

            <div
               *ngIf="!app.isPhoneVerified"
               [ngClass]="{
                  'error-message': true,
                  'error-warning': app.phoneVerificationErrorType === '2'
               }">
               ({{ errorTypeMap[app.phoneVerificationErrorType || 0] }})
            </div>
         </div>
      </div>
   </div>
</div>
